"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Image from "next/image";
import { ASSET_PREFIX } from "@/config";  

export default function VideoPopupGallery() {
  const [activeVideo, setActiveVideo] = useState<string | null>(null);
  // 🎬 Video Data
  const video = {
    id: 1,
    thumbnail: "/images/blogs/unitd-living-space-signs-128-crore-mou-for-a-new-it-project-in-saravanampatti-video-popup.webp",
    youtubeUrl: "https://www.youtube.com/watch?v=KogTpMLOt4Q",
    title: "UNITD Living Space takes a bold step into the future with UNITD OS - Office Space.",
  };

  // 🎥 Convert YouTube URL to embed link
  const getYouTubeEmbedUrl = (url: string) => {
    const videoId = url.split("v=")[1]?.split("&")[0] || "";
    return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
  };

  return ( 
      <div > 

      <div>
        <div
          className="relative cursor-pointer group overflow-hidden rounded-2xl w-auto max-h-auto"
          onClick={() => setActiveVideo(video.youtubeUrl)}>
          <Image
            src={`${ASSET_PREFIX}${video.thumbnail}`}
            alt={video.title}
            width={600}
            height={400}
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          />

          {/* Play Button Overlay */}
          <div className="flex items-center justify-center w-full h-full absolute bottom-0 top-[50px]">
            <svg
              xmlns="https://www.w3.org/2000/svg"
              className="h-16 w-16 text-white opacity-90 group-hover:scale-110 transition-transform"
              fill="currentColor"
              viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
          <div className="absolute inset-0 bg-black/20 "> 
          </div>
        </div>

        {/* OUTSIDE THE BOX */}
        <h3 className="text-[18px] leading-[28px] mt-[18px] font-[500] mb-[15px] tracking-[-0.03em] text-[#000] max-[1440px]:text-[18px] max-[1440px]:leading-[28px]">
          {video.title}
        </h3>
      </div>

      {/* Popup Modal */}
      <AnimatePresence>
        {activeVideo && (
          <motion.div
            key="popup"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/80 flex items-center justify-center z-[999]"
            onClick={() => setActiveVideo(null)}>
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              onClick={(e) => e.stopPropagation()}
              className="relative w-[90%] max-w-[900px] aspect-video bg-black rounded-xl overflow-hidden">
              <iframe
                src={getYouTubeEmbedUrl(activeVideo)}
                title="YouTube video"
                allow="autoplay; fullscreen"
                allowFullScreen
                className="w-full h-full"></iframe>

              {/* Close Button */}
              <button
                onClick={() => setActiveVideo(null)}
                className="absolute top-3 right-3 bg-white/20 hover:bg-white/40 text-white rounded-full w-10 h-10 flex items-center justify-center text-xl cursor-pointer">
                ✕
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      </div> 
  );
}